<template>
  <div>
    <multiselect
      class="ports-multiselect"
      v-model="searchValue"
      :internal-search="false"
      :loading="searchLoading"
      :options="searchResults"
      @search-change="handleSearchChange"
      @input="handleEntitySelected"
      :preserve-search="true"
      :close-on-select="true"
      group-values="items"
      group-label="label"
      :group-select="false"
      label="name"
      track-by="entityId"
      selectLabel=""
      placeholder="Search">

      <div slot="beforeList">
        <!-- nothing -->
      </div>

      <template #noResult>
        <span>No results found</span>
      </template>

      <template slot="singleLabel" slot-scope="{ option }">
        <div class="selected-label">
          {{ option.name }} ({{ option.id }})
        </div>
      </template>

      <template slot="option" slot-scope="{ option }">
        <div v-if="option.$isLabel" class="custom-option">
          <div class="option-title">
            <h5 class="m-0 p-0 text-center">{{ startCase(option.$groupLabel) }}</h5>
          </div>
        </div>

        <div v-else class="custom-option">

          <template v-if="option.type === 'Port'">
            <div class="option-title d-flex justify-content-between" :title="option.name">
              <div>{{ option.name }}</div>
              <div>Port Id: <strong>{{ option.portId }}</strong></div>
            </div>
          </template>

          <template v-else>
            <div class="option-title" :title="option.name">{{ option.name }}</div>
            <div class="option-details">
              <span>
                {{ option.type }} Id: <strong>{{ option.id }}</strong>
              </span>
              <span>
                Port Id: <strong>{{ option.portId }}</strong>
              </span>
            </div>
          </template>

        </div>
      </template>
    </multiselect>

  </div>
</template>

<script>

import debounce from 'lodash-es/debounce'
import getNested from 'lodash-es/get'
import startCase from 'lodash-es/startCase'
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex'

const entityMap = {
  port: {
    id: 'portId',
    portId: 'portId',
    name: 'portName',
  },
  berth: {
    id: 'berthId',
    portId: 'portId',
    name: 'berthName',
  },
  anchorage: {
    id: 'anchorageId',
    portId: 'primaryPort',
    name: 'anchorageName',
  },
  shipyard: {
    id: 'shipyardId',
    portId: 'portId',
    name: 'shipyardName',
  },
};


export default {
  name: 'port-search',

  components: {
    Multiselect,
  },

  props: {
    //...
  },

  data() {
    return {
      searchLoading: false,
      searchResults: [],
      searchValue: null,
    };
  },

  async mounted() {
    // ...
  },

  methods: {
    startCase: startCase,

    ...mapActions(
      'polygons', [
        'searchEntities',
      ]
    ),

    handleSearchChange: debounce(async function(searchString) {
      if(searchString.length < 2) {
        this.searchResults = [];
        return;
      }

      this.searchLoading = true;
      if(searchString) {
        let searchResults = await this.searchEntities(searchString);
        this.searchResults = this.formatSearchResults(searchResults);
      } else {
        this.searchResults = [];
      }

      this.searchLoading = false;
    }, 300),

    formatSearchResults(searchResults) {
      let formattedResults = [];

      // anchorages: item.primaryPort
      // berths: item.portId

      Object.keys(entityMap).forEach(entityType => {
        let items = getNested(searchResults, `${entityType}s`, []);

        if(items.length) {
          let section = { label: `${entityType}s` };
          section.items = items.map(item => this.convertEntityData(entityType, item));
          formattedResults.push(section);
        }
      });

      return formattedResults;
    },

    convertEntityData(entityType, item) {
      const sectionMap = entityMap[entityType];
      let convertedItem = {};
      Object.keys(sectionMap).forEach(fieldName => {
        convertedItem[fieldName] = item[sectionMap[fieldName]];
      });
      convertedItem.type = startCase(entityType);
      convertedItem.entityId = `${entityType}-${convertedItem.id}`;

      return convertedItem;
    },

    handleEntitySelected(item) {
      if(item.portId === this.getPortId()) {
        return;
      }

      this.searchValue = null;
      this.$router.push({
        name: 'Port Details',
        params: { port_id: item.portId }
      });
    },

    getPortId() {
      let portId = getNested(this, '$route.params.port_id', null);
      if(portId) {
        return parseInt(portId);
      } else {
        return null;
      }
    },
  },

  watch: {
    // ...
  },
}
</script>

<style scoped>
  .ports-multiselect >>> .multiselect__content {
    width: 100%;
    overflow: hidden;
  }
  .ports-multiselect >>> .multiselect__tags {
    padding: 4px 40px 0 5px;
    min-height: 30px;
  }
  .ports-multiselect.multiselect--active >>> .multiselect__tags {
    padding-top: 7px;
  }
  .ports-multiselect >>> .multiselect__placeholder {
    margin-bottom: 3px;
  }
  .ports-multiselect >>> .multiselect__select {
    height: 30px;
  }
  .ports-multiselect >>> .multiselect__single {
    margin-bottom: 3px;
  }

  .ports-multiselect >>> .multiselect__option--group {
    background-color: #64bfff !important;
    color: white !important;
  }

</style>

<style scoped lang="scss">

  .ports-multiselect {
    width: 200px;
    transition: all 0.2s;
  }

  .ports-multiselect.multiselect--active {
    min-width: 400px;
    max-width: 50%;
    transition: all 0.2s;
  }

  .ports-multiselect {
    min-height: 30px;

    .selected-label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .custom-option {
      .option-title {
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .option-details {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-size: 14px;
        color: #5e5e5e;
      }
    }
  }

</style>